import { XIcon } from "@wags/ui/product-icons.tsx";

import { DrawerClose, DrawerContent } from "@wags/ui/drawer.tsx";
import { MobileAuthForm, type MobileAuthFormProps } from "./mobile-auth-form";

export function MobileAuthDrawerContent(props: MobileAuthFormProps) {
    return (
        <DrawerContent
            title="Sign in or sign up to Wags"
            layerClassName="z-[60]"
            className="max-h-[calc(100dvh-0.75rem)] min-h-0 gap-0 overflow-clip border-t-0 p-0"
        >
            <DrawerClose
                variant="tile"
                aria-label="Close"
                className="absolute top-7 right-4 z-10"
            >
                <XIcon className="size-5" />
            </DrawerClose>
            <MobileAuthForm {...props} />
        </DrawerContent>
    );
}
